import type { CustomizationRepository } from '../../domain/interfaces/CustomizationRepository';
import type { CustomizationParams } from '../../domain/interfaces/CustomizationRepository';
import type { ProductCustomization } from '../../domain/models/ProductCustomization';

export type CustomizationService = ReturnType<typeof createCustomizationService>;

export function createCustomizationService(repo: CustomizationRepository) {
  return {
    //created two methods for scalable so that if we split customization apis like get for preview and post for apply customization we can easily use them separately.
    previewCustomization(designId: string, params: CustomizationParams): Promise<ProductCustomization> {
      return repo.fetchCustomization(designId, params);
    },

    applyCustomization(designId: string, params: CustomizationParams): Promise<ProductCustomization> {
      return repo.fetchCustomization(designId, params);
    },
  };
}
